export default "__VITE_ASSET__CwxSy6F8__"